<template>
   <div class="modal-body">
        <RequiredText />
        <div class="row">
            <Input
                containerClass="col-6 mb-2"
                name="taxe"
                :label="$t('label.title')"
                :placeholder="$t('label.title')"
                v-model="formData.title"
            />
            <Select2
                :parent-id="'#'+id"
                containerClass="col-6 mb-2"
                :name="'category-'+id"
                :show-search="false"
                :multiple="false"
                :label="$t('label.category')"
                :placeholderText="$t('label.category')"
                v-model="formData.category">
                <option v-for="category in categories" :key="category.value" :value="category.value">
                    {{ category[locale] }}
                </option>
            </Select2>
        </div>
        <AmountWithTypeInput
            v-if="!withBracket && formData.payroll_tax_data?.length"
            :id="id"
            v-model:type="formData.payroll_tax_data[0].type"
            v-model:amount="formData.payroll_tax_data[0].value"
        />

        <SwitchInput id="bracket" :label="$t('label.withBracket')" v-model="withBracket"/>
        <div v-if="withBracket">
        <Card class="card p-5 mb-5" v-for="(content,index) in formData.payroll_tax_data" :key="index">
            <BracketInput v-model:min="content.range_min" v-model:max="content.range_max" @update:max="(value) => updateNextMin(index, value)" @update:min="(value) => updatePrevMax(index, value)"/>
            <AmountWithTypeInput :index="index" :id="id" v-model:type="content.type" v-model:amount="content.value"/>
            <div class="end">
            <Button btn-class="btn-sm me-3" type="new" background-color="red" iconClass="fa fa-trash" @click.prevent="dropBracket(index)"  />
            </div>
        </Card> 
        <br>
        <Button btn-class="btn-sm me-3" type="new"  btn-text="label.addBracket"  @click.prevent="addBracket(index)"/>
        </div>
    </div>
</template>

<script setup>

import { defineProps,ref, watch } from 'vue';
import { useStore } from "vuex";
import RequiredText from "@/components/RequiredText"
import Button from "@/components/Button.vue"
import Input from "@/components/Input";
import Select2 from '@/components/Select2.vue';
import BracketInput from '../../components/BracketInput.vue';
import AmountWithTypeInput from '../../components/AmountWithTypeInput.vue';
import SwitchInput from '@/components/SwitchInput.vue';
import Card from '@/Modules/CRM/components/Card.vue';
import { computed } from 'vue';
import { useLocales } from '@/composables/locales';

const {locale} = useLocales()
const props = defineProps({
    formData:{
        type:Object,
        default:{}
    },
    categories:{
        type:Array,
        default:[]
    },
    id:{type: String, default:"create_modal"}
})

const withBracket = ref(false)
const formData = ref(props.formData)

watch(() => props.formData, (value) => {  
    formData.value = props.formData
    if(props.formData.payroll_tax_data?.length > 1){
        withBracket.value = true
    }
}, { deep: true })


watch(() => withBracket.value, (value) => {
    if(!value && !formData.value.payroll_tax_data.length){
        addBracket()
    }
})

const addBracket = () => {
    let last = formData.value.payroll_tax_data.slice(-1)[0];
    let lastMax = last && !isNaN(Number(last.range_max)) ? Number(last.range_max) : 0;

    formData.value.payroll_tax_data.push({
        type: 'amount',
        value: 0,
        range_min: lastMax+1,
        range_max: ''
    })
}

const dropBracket = (key) => {
    formData.value.payroll_tax_data.splice(key, 1)
}

const updateNextMin = (index, value) => {
  if(formData.value.payroll_tax_data.length > index + 1){
    formData.value.payroll_tax_data[index + 1].range_min = value + 1
  }
}

const updatePrevMax = (index, value) => {
  if(index > 0){
    formData.value.payroll_tax_data[index - 1].range_max = value - 1
  }
}

</script>
<style>
.end{
  display: flex;
  justify-content: end;
}
.back{
    background-color: var(--bs-light-primary);
    border-radius: 8px;
  padding: 5px;
  width: auto;
}
</style>